// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"CloseButton-module_closeIcon__1AvwQ2i5OTzQNJjzbNOdrS"};